var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.13636 13.9048C8.56313 13.9048 8.90909 13.5636 8.90909 13.1429C8.90909 12.7221 8.56313 12.381 8.13636 12.381C7.7096 12.381 7.36364 12.7221 7.36364 13.1429C7.36364 13.5636 7.7096 13.9048 8.13636 13.9048Z",
    fill: "currentColor",
    fillOpacity: 0.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.1429C12 13.5636 11.654 13.9048 11.2273 13.9048C10.8005 13.9048 10.4545 13.5636 10.4545 13.1429C10.4545 12.7221 10.8005 12.381 11.2273 12.381C11.654 12.381 12 12.7221 12 13.1429Z",
    fill: "currentColor",
    fillOpacity: 0.9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3182 13.9048C14.7449 13.9048 15.0909 13.5636 15.0909 13.1429C15.0909 12.7221 14.7449 12.381 14.3182 12.381C13.8914 12.381 13.5455 12.7221 13.5455 13.1429C13.5455 13.5636 13.8914 13.9048 14.3182 13.9048Z",
    fill: "currentColor",
    fillOpacity: 0.9
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.90909 16.1905C8.90909 16.6113 8.56313 16.9524 8.13636 16.9524C7.7096 16.9524 7.36364 16.6113 7.36364 16.1905C7.36364 15.7697 7.7096 15.4286 8.13636 15.4286C8.56313 15.4286 8.90909 15.7697 8.90909 16.1905Z",
    fill: "currentColor",
    fillOpacity: 0.9
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2273 16.9524C11.654 16.9524 12 16.6113 12 16.1905C12 15.7697 11.654 15.4286 11.2273 15.4286C10.8005 15.4286 10.4545 15.7697 10.4545 16.1905C10.4545 16.6113 10.8005 16.9524 11.2273 16.9524Z",
    fill: "currentColor",
    fillOpacity: 0.9
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.90909 4.7619C8.90909 4.34112 8.56313 4 8.13636 4C7.7096 4 7.36364 4.34112 7.36364 4.7619V5.52381H5.81818C4.53789 5.52381 3.5 6.54716 3.5 7.80952V17.7143C3.5 18.9767 4.53789 20 5.81818 20H18.1818C19.4621 20 20.5 18.9767 20.5 17.7143V7.80952C20.5 6.54716 19.4621 5.52381 18.1818 5.52381H16.6364V4.7619C16.6364 4.34112 16.2904 4 15.8636 4C15.4369 4 15.0909 4.34112 15.0909 4.7619V5.52381H8.90909V4.7619ZM5.04545 7.80952C5.04545 7.38874 5.39142 7.04762 5.81818 7.04762H18.1818C18.6086 7.04762 18.9545 7.38874 18.9545 7.80952V9.33333H5.04545V7.80952ZM5.04545 10.8571H18.9545V17.7143C18.9545 18.1351 18.6086 18.4762 18.1818 18.4762H5.81818C5.39142 18.4762 5.04545 18.1351 5.04545 17.7143V10.8571Z",
    fill: "currentColor",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.269b771716b3b3d61461e1d5bbb6081c.svg";
export { ForwardRef as ReactComponent };